import { useCallback } from "react"
import { useDispatch } from "react-redux"
import { setNextRandomAlbumAsPointed } from "../../actions/randomModeActions"

export const useNextAlbum = () => {
    const dispatch = useDispatch();

    return useCallback(() => {
        dispatch(setNextRandomAlbumAsPointed())
    }, [dispatch]);
}